import { TpSlError } from '../TpSlError/TpSlError';
import { ProfitText } from './ProfitText';

export const StopOrderMessage = ({
  hasError,
  isInputFocused,
  price,
  hasExistingOrder,
  pnl,
  pnlPercentage,
  type,
  priceDecimals,
  stopLossPrice,
  takeProfitPrice,
  side,
  productId,
  TpSlErrorComp,
}: {
  hasError: boolean;
  isInputFocused: boolean;
  price: bigint | undefined;
  hasExistingOrder: boolean;
  pnl: bigint | undefined;
  pnlPercentage: bigint | undefined;
  type: 'tp' | 'sl';
  priceDecimals: number;
  stopLossPrice: bigint | undefined;
  takeProfitPrice: bigint | undefined;
  side: 'long' | 'short';
  productId: string;
  TpSlErrorComp: typeof TpSlError;
}) => {
  // Show error when there's an error and input is not focused
  if (hasError && !isInputFocused) {
    return (
      <TpSlErrorComp
        stopLossPrice={stopLossPrice}
        takeProfitPrice={takeProfitPrice}
        side={side}
        tpOrSl={type}
        productId={productId}
        hideError={false}
      />
    );
  }

  // Show cancel message when there's an existing order but no price
  if (hasExistingOrder && !price) {
    const orderType = type === 'tp' ? 'Take Profit' : 'Stop Loss';
    return (
      <p className="text-3xs text-contentSecondary">
        This action will cancel your current {orderType} Market trigger.
      </p>
    );
  }

  // Otherwise, always show profit text
  return (
    <ProfitText
      price={price}
      pnl={pnl}
      pnlPercentage={pnlPercentage}
      type={type}
      priceDecimals={priceDecimals}
    />
  );
};
